import Api from 'utils/ApiRequest'
import API_URL from 'constants/api'
import { showSpinner, hideSpinner } from 'action/spinner'
import { push } from 'react-router-redux'

import {
  FETCH_USAGE_CONSUMPTION_APPROVERS_REQUEST,
  FETCH_USAGE_CONSUMPTION_APPROVERS_SUCCESS,
  FETCH_USAGE_CONSUMPTION_APPROVERS_ERROR,
  UPDATE_USAGE_CONSUMPTION_APPROVERS_REQUEST,
  UPDATE_USAGE_CONSUMPTION_APPROVERS_SUCCESS,
  CHANGE_USAGE_CONSUMPTION_APPROVERS_REQUEST,
  CHANGE_USAGE_CONSUMPTION_APPROVERS_SUCCESS,
  CHANGE_USAGE_CONSUMPTION_APPROVERS_ERROR,
  DELETE_USAGE_CONSUMPTION_APPROVERS_SUCCESS,
  DELETE_USAGE_CONSUMPTION_APPROVERS_REQUEST,
  DELETE_USAGE_CONSUMPTION_APPROVERS_ERROR,
  UPDATE_USAGE_CONSUMPTION_APPROVERS_ERROR,
  USAGE_CONSUMPTION_RESET,
  GET_MENU_MISSION_FROM_LIST,
  RESET_MENU_MISSIONS,
  RESET_EDIT_MENU_MISSION,
  REMOVE_MENU_MISSION_SUCCESS,
  REMOVE_MENU_MISSION_ERROR,
  GET_PAGES,
  CLEAR_SUCCESS_MESSAGE,
  FETCH_MISSIONS_OPTIONS_REQUEST,
  FETCH_MISSIONS_OPTIONS_SUCCESS,
  FETCH_MISSIONS_OPTIONS_ERROR,
  FETCH_USE_CONSUME_APPROVERS_REQUEST,
  FETCH_USE_CONSUME_APPROVERS_ERROR,
  FETCH_USE_CONSUME_APPROVERS_SUCCESS,
} from 'actionTypes'

const getPages = (page, data, dispatch) => {
  const qtt = data.length
  const qtd = 10
  let pages = Math.floor(qtt / qtd)
  if (qtt % qtd > 0) {
    pages += 1
  }
  const begin = (page - 1) * qtd
  const end = page * qtd
  data = data.slice(begin, end)
  fetchUsageConsumptionApproversSuccess(data, dispatch)

  return {
    type: GET_PAGES,
    pages,
    current: page,
    count: qtt,
  }
}



export const fetchUsageConsumptionApprovers =
  (token, page = 1) =>
  (dispatch) => {
    dispatch(fetchUsageConsumptionApproversRequest())

    return new Api(token, dispatch)
      .get(API_URL.USAGE_CONSUMPTION_APPROVERS_LIST)
      .then(dispatch(showSpinner()))
      .then((response) => {
        dispatch(getPages(page, response.data, dispatch))
        dispatch(hideSpinner())
      })
      .catch((error) => {
        dispatch(fetchUsageConsumptionApproversError(error))
        dispatch(hideSpinner())
      })
  }

  export const fetchUseConsumeApprovers =
  (token, query) =>
  (dispatch) => {
    dispatch(fetchUseConsumeApproversRequest())

    return new Api(token, dispatch)
      .get(API_URL.USE_CONSUME_APPROVERS_LIST , query)
      .then(dispatch(showSpinner()))
      .then((response) => {
    
        dispatch(fetchUseConsumeApproversSucces(response.data))
        dispatch(hideSpinner())
      })
      .catch((error) => {
        dispatch(fetchUseConsumeApproversError(error))
        dispatch(hideSpinner())
      })
  }
export const fetchUsageConsumptionApproversRequest = () => ({
  type: FETCH_USAGE_CONSUMPTION_APPROVERS_REQUEST,
})

export const fetchUseConsumeApproversRequest = () => ({
  type: FETCH_USE_CONSUME_APPROVERS_REQUEST,
})

export const fetchUseConsumeApproversError = (data) => ({
  type: FETCH_USE_CONSUME_APPROVERS_ERROR,
  error: data
})

export const fetchUseConsumeApproversSucces = (data) => ({
  type: FETCH_USE_CONSUME_APPROVERS_SUCCESS,
  payload: data
})
export const fetchUsageConsumptionApproversSuccess = (data, dispatch) => {
  if (data) {
    dispatch(usageConsumptionApproversSuccess(data))
  }
  dispatch(hideSpinner())
}

const usageConsumptionApproversSuccess = (data) => ({
  type: FETCH_USAGE_CONSUMPTION_APPROVERS_SUCCESS,
  payload: data,
})

export const fetchUsageConsumptionApproversError = (error) => ({
  type: FETCH_USAGE_CONSUMPTION_APPROVERS_ERROR,
  payload: error,
})

export const update = (token, params, onSuccess) => (dispatch) => {
  dispatch(updateUsageConsumptionApproversRequest())

  return new Api(token, dispatch)
    .post(API_URL.USAGE_CONSUMPTION_APPROVERS_SAVE, params)
    .then(dispatch(showSpinner()))
    .then((response) => {
      dispatch(updateUsageConsumptionApproversSuccess(response.data))
      dispatch(fetchUsageConsumptionApprovers(token))
      dispatch(fetchMissionsOptions(token))
      onSuccess && onSuccess()
    })
    .catch((error) => {
      dispatch(updateUsageConsumptionApproversError(error))
    })
    .finally(() => dispatch(hideSpinner()))
}


export const resetUseConsumeApprovers = () => ({
  type: USAGE_CONSUMPTION_RESET,

})

export const resetSave = () => (dispatch) =>  {
  dispatch(resetUseConsumeApprovers())
}


export const changeUsageConsumptionApproversRequest = () => ({
  type: CHANGE_USAGE_CONSUMPTION_APPROVERS_REQUEST,
})

export const changeUsageConsumptionApproversSuccess = (data) => ({
  type: CHANGE_USAGE_CONSUMPTION_APPROVERS_SUCCESS,
  payload: data,
})

export const changeUsageConsumptionApproversError = (error) => ({
  type: CHANGE_USAGE_CONSUMPTION_APPROVERS_ERROR,
  payload: error,
})

export const updatePermissions = (token, params, callbackSave) => (dispatch) => {
  dispatch(changeUsageConsumptionApproversRequest())

  return new Api(token, dispatch)
    .put(API_URL.USE_CONSUME_APPROVERS_EDIT, params)
    .then(dispatch(showSpinner()))
    .then((response) => {
      dispatch(changeUsageConsumptionApproversSuccess(response))
      callbackSave()
    })
    .catch((error) => {
      dispatch(changeUsageConsumptionApproversError(error))
    })
    .finally(() => dispatch(hideSpinner()))
}


export const deleteUsageConsumptionApproversRequest = () => ({
  type: DELETE_USAGE_CONSUMPTION_APPROVERS_REQUEST,
})

export const deleteUsageConsumptionApproversSuccess = (data) => ({
  type: DELETE_USAGE_CONSUMPTION_APPROVERS_SUCCESS,
  payload: data,
})

export const deleteUsageConsumptionApproversError = (error) => ({
  type: DELETE_USAGE_CONSUMPTION_APPROVERS_ERROR,
  payload: error,
})

export const deletePermissions = (token, params, callBackDelete) => (dispatch) => {
  dispatch(deleteUsageConsumptionApproversRequest())
  return new Api(token, dispatch)
    .deleteWithBody(API_URL.USE_CONSUME_APPROVERS_REMOVE, params)
    .then(dispatch(showSpinner()))
    .then((response) => {
      
        dispatch(deleteUsageConsumptionApproversSuccess(response))
      
    })
    .catch((error) => {
      
      dispatch(deleteUsageConsumptionApproversError(error))
    })
    .finally(() => {
      dispatch(hideSpinner())
      callBackDelete()
    })
}

export const preserve = (token, params, callbackSave) => (dispatch) => {
  dispatch(updateUsageConsumptionApproversRequest())

  return new Api(token, dispatch)
    .post(API_URL.USE_CONSUME_APPROVERS_SAVE, params)
    .then(dispatch(showSpinner()))
    .then((response) => {

      if(response.cdStatus === 409 || response.cdStatus === 500 || response.cdStatus === 400 ) {
        dispatch(updateUsageConsumptionApproversError(response))
      }

      else { 
        dispatch(updateUsageConsumptionApproversSuccess(response))
        dispatch(fetchMissionsOptionsv2(token))
        callbackSave()
      }

    
    })
    .catch((error) => {
      dispatch(updateUsageConsumptionApproversError(error))
    })
    .finally(() => dispatch(hideSpinner()))
}

export const updateUsageConsumptionApproversRequest = () => ({
  type: UPDATE_USAGE_CONSUMPTION_APPROVERS_REQUEST,
})

export const updateUsageConsumptionApproversSuccess = (data) => ({
  type: UPDATE_USAGE_CONSUMPTION_APPROVERS_SUCCESS,
  payload: data,
})

export const updateUsageConsumptionApproversError = (error) => ({
  type: UPDATE_USAGE_CONSUMPTION_APPROVERS_ERROR,
  payload: error,
})

/*
 * GET MENU_MISSION FROM LIST
 */
export const getMenuMission = (index) => (dispatch) => {
  dispatch({
    type: GET_MENU_MISSION_FROM_LIST,
    index,
  })

  dispatch(push(`/missions/${index}`))
}

export const remove = (token, lsMissionMenus) => (dispatch) =>
  new Api(token, dispatch)
    .post(API_URL.USAGE_CONSUMPTION_APPROVERS_REMOVE, lsMissionMenus)
    .then(dispatch(showSpinner()))
    .then(() => {
      dispatch(removeMissionSuccess())
      dispatch(fetchUsageConsumptionApprovers(token))
      dispatch(fetchMissionsOptions(token))
      dispatch(hideSpinner())
    })
    .catch((error) => {
      dispatch(removeMissionError(error))
      dispatch(hideSpinner())
    })

export const removeMissionSuccess = () => ({
  type: REMOVE_MENU_MISSION_SUCCESS,
})

export const removeMissionError = (error) => ({
  type: REMOVE_MENU_MISSION_ERROR,
  payload: error,
})

export const resetMenuMissions = () => ({
  type: RESET_MENU_MISSIONS,
})

export const resetEditMenuMissions = () => ({
  type: RESET_EDIT_MENU_MISSION,
})

export const clearSuccessMessage = () => ({
  type: CLEAR_SUCCESS_MESSAGE,
})

export const fetchMissionsOptions = (token) => (dispatch) => {
  dispatch(fetchMissionsOptionsRequest())

  return new Api(token, dispatch)
    .get(API_URL.USAGE_CONSUMPTION_APPROVERS_LIST_MISSION)
    .then(dispatch(showSpinner()))
    .then((response) => {
      dispatch(fetchMissionsOptionsSuccess(response.data))
      dispatch(hideSpinner())
    })
    .catch((error) => {
      dispatch(fetchMissionsOptionsError(error))
      dispatch(hideSpinner())
    })
}

export const fetchMissionsOptionsv2 = (token) => (dispatch) => {
  dispatch(fetchMissionsOptionsRequest())

  return new Api(token, dispatch)
    .get(API_URL.USE_CONSUME_APPROVERS_LIST_MISSION)
    .then(dispatch(showSpinner()))
    .then((response) => {
      dispatch(fetchMissionsOptionsSuccess(response.data))
      dispatch(hideSpinner())
    })
    .catch((error) => {
      dispatch(fetchMissionsOptionsError(error))
      dispatch(hideSpinner())
    })
}



export const fetchMissionsOptionsRequest = () => ({
  type: FETCH_MISSIONS_OPTIONS_REQUEST,
})

export const fetchMissionsOptionsSuccess = (data) => ({
  type: FETCH_MISSIONS_OPTIONS_SUCCESS,
  payload: data,
})

export const fetchMissionsOptionsError = (error) => ({
  type: FETCH_MISSIONS_OPTIONS_ERROR,
  payload: error,
})
